import { 
    findOrdersByCompanyState, 
    findOrdersByCompany,
    findOrdersByCompanyGroupDate,
    findOrdersByCompanyGroupClient,
    findOrdersByCompanyGroupDatePaged,
    findOrdersDesp,
    findOrdersDetailChecked,
    resetCheckeOrders,
    findAllByGroupDetails,
    findAllByGroupDetailsForClient,
    findOrdersByClient,
    findAllByGroupDetailsOrder,
    findOrdersIdsByCompanyAndDate,
    findOrdersIdsByCompany,
    generateOrderStateReportOrdersByClient,
    groupPending,
    groupPendingMarked,
    groupPendingEnro,
    groupPendingPdf,
    groupPendingMarkedPdf,
    groupPendingEnroPdf
} from '../../_services/order.service';
import { getCompany } from '../../_utils/storage_handler';

const PENDING_STATE = 'PEND';


export const resetCheckeOrdersEvent = async () => {
    let res = await resetCheckeOrders(getCompany());
    if(! res.ok) throw new Error(res.error);
    return res;
}

export const findPendingOrdersEvent = async () => {
    let res = await findOrdersByCompanyState(getCompany(), PENDING_STATE);
    if(! res.ok) throw new Error(res.error);
    return res;
}

export const findOrdersDespEvent = async () => {
    let res = await findOrdersDesp(getCompany());
    if(! res.ok) throw new Error(res.error);
    return res;
}

export const findOrdersDetailCheckedEvent = async () => {
    let res = await findOrdersDetailChecked(getCompany());
    if(! res.ok) throw new Error(res.error);
    return res;
}

export const findOrdersEvent = async (state) => {
    let res = await findOrdersByCompanyState(getCompany(), state);
    if(! res.ok) throw new Error(res.error);
    return res;
}

export const findAllByCompanyOrdersEvent = async () => {
    let res = await findOrdersByCompany(getCompany());
    if(! res.ok) throw new Error(res.error);
    return res;
}

export const findAllByGroupDetailsEvent = async () => {
    let res = await findAllByGroupDetails();
    if(! res.ok) throw new Error(res.error);
    return res;
}

export const findAllByCompanyOrdersGroupDateEvent = async (dateStart,dateEnd) => {
    let body={
        dateStart,
        dateEnd,
        company:getCompany()
    }
    let res = await findOrdersByCompanyGroupDate(body);
    if(! res.ok) throw new Error(res.error);
    return res;
}

export const findOrdersByClientEvent = async (uuid) => {
    let res = await findOrdersByClient(getCompany(),uuid);
    if(! res.ok) throw new Error(res.error);
    return res;
}

export const findAllByCompanyOrdersGroupDatePagedEvent = async (refDate, days) => {
    let res = await findOrdersByCompanyGroupDatePaged(getCompany(), refDate, days);
    if(! res.ok) throw new Error(res.error);
    return res;
}

export const findAllByCompanyOrdersGroupClientEvent = async () => {
    let res = await findOrdersByCompanyGroupClient(getCompany());
    if(! res.ok) throw new Error(res.error);
    return res;
}

export const findAllByGroupDetailsForClientEvent = async () => {
    let res = await findAllByGroupDetailsForClient();
    if(! res.ok) throw new Error(res.error);
    return res;
}

export const findAllByGroupDetailsOrderEvent = async (uuid_order) => {
    let res = await findAllByGroupDetailsOrder(uuid_order);
    if(! res.ok) throw new Error(res.error);
    return res;
}


export const findOrdersIdsByCompanyEvent = async () => {
    let res = await findOrdersIdsByCompany();
    if(! res.ok) throw new Error(res.error);
    return res;
}

export const findOrdersIdsByCompanyAndDateEvent = async (dateStart,dateEnd) => {
    let res = await findOrdersIdsByCompanyAndDate(dateStart,dateEnd);
    if(! res.ok) throw new Error(res.error);
    return res;
}

export const generateOrderStateReportOrdersByClientEvent = async (uuid) => {
    let res = await generateOrderStateReportOrdersByClient(getCompany(),uuid);
    if(! res.ok) throw new Error(res.error);
    return res;
}

export const groupPendingEvent = async () => {
    let res = await groupPending();
    if(! res.ok) throw new Error(res.error);
    return res;
}

export const groupPendingMarkedEvent = async () => {
    let res = await groupPendingMarked();
    if(! res.ok) throw new Error(res.error);
    return res;
}

export const groupPendingEnroEvent = async () => {
    let res = await groupPendingEnro();
    if(! res.ok) throw new Error(res.error);
    return res;
}

export const groupPendingPdfEvent = async () => {
    let res = await groupPendingPdf();
    if(! res.ok) throw new Error(res.error);
    return res;
}

export const groupPendingMarkedPdfEvent = async () => {
    let res = await groupPendingMarkedPdf();
    if(! res.ok) throw new Error(res.error);
    return res;
}

export const groupPendingEnroPdfEvent = async () => {
    let res = await groupPendingEnroPdf();
    if(! res.ok) throw new Error(res.error);
    return res;
}
